import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import { actionLoadSiteTextsWithConfigRequest } from '../../actions/loadSiteTextsWithConfig';

import { getCurrentSiteId } from '../../../site/selectors';
import { getLoadSiteTextsWithConfigError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadSiteTextsWithConfigHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadSiteTextsWithConfigRequest(getCurrentSiteId(getState()))
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadSiteTextsWithConfigError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadSiteTextsWithConfigHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
